
/**
 * Utility functions for password validation
 */

// List of commonly used passwords that should be rejected
// This is a very basic list - in production you might want something more comprehensive
const commonPasswords = [
  "password", "123456", "12345678", "qwerty", "abc123", "monkey", "1234567", 
  "letmein", "trustno1", "dragon", "baseball", "111111", "iloveyou", "master", 
  "sunshine", "ashley", "bailey", "passw0rd", "shadow", "123123", "654321", 
  "superman", "qazwsx", "michael", "football", "welcome", "jesus", "ninja", 
  "mustang", "password1", "123456789", "adobe123", "admin", "1234567890", 
  "photoshop", "1234", "12345", "princess", "azerty", "0", "access", "696969", 
  "batman", "1qaz2wsx"
];

/**
 * Checks if a password is too common or weak
 * @param password The password to check
 * @returns An error message if the password is weak, null otherwise
 */
export const validatePassword = (password: string): string | null => {
  // Check for minimum length
  if (password.length < 8) {
    return "Password must be at least 8 characters long";
  }

  // Check if it's a common password
  if (commonPasswords.includes(password.toLowerCase())) {
    return "This password is too common and easily guessed. Please choose a stronger password";
  }

  // Check for password complexity (at least one number AND one special character or uppercase letter)
  const hasNumber = /\d/.test(password);
  const hasSpecialOrUpper = /[A-Z!@#$%^&*(),.?":{}|<>]/.test(password);
  
  if (!(hasNumber && hasSpecialOrUpper)) {
    return "Password must contain at least one number and either an uppercase letter or special character";
  }

  return null;
};
